import { useEffect, useContext } from 'react';
import { parseCookies } from "nookies";
import AuthContext from "../store/auth-context";

export const SetAnalyticsData = () => {
  const authCtx = useContext(AuthContext);
  //console.log("authCtx sessionUser: " + JSON.stringify(authCtx.sessionUser));
  const sessionUser = authCtx.sessionUser;
  const isLoggedIn = sessionUser && sessionUser.loggedIn ? sessionUser.loggedIn : false;
  const email = sessionUser && sessionUser.emailId ? sessionUser.emailId : '';

  //Check if it is punchout session
  const isPunchOutSession = authCtx?.isLoggedIn && authCtx?.sessionUser?.b2bUser;
  //console.log("isPunchOutSession:" + isPunchOutSession);
  let b2xSessionType = 'B2C';
  if (isPunchOutSession) {
    b2xSessionType = 'B2B';
  }

  
  const existCookies = parseCookies();
  //console.log("existCookies: " + JSON.stringify(existCookies));
  let pageUrl = window.location.pathname;
  console.log("Current page url: ", pageUrl);
  if (pageUrl.indexOf('quote-app') === -1) {
    pageUrl = '/quote-app' + pageUrl;
  }
  pageUrl = pageUrl.replace(/^\/|\/$/g, '');
  const countryLang = existCookies.evCntryLang
    ? existCookies.evCntryLang.split("-")
    : ["US", "en"];
  const country = countryLang[0];
  const lang = countryLang[1];

  let loginStatus = 'not logged in';
  if (isLoggedIn) {
    loginStatus = 'logged in - partially registered';
    if (sessionUser && sessionUser.hasAccount) {
      loginStatus = 'logged in - fully registered';
    }
  }
  
  // Adobe Analytics - userView & pageView events
  useEffect(() => {

    const profile = {
      attributes: {
        b2xSessionType,
        loginStatus
      }
    }
        
    if (isLoggedIn && email) {
      const bitArray = window.sjcl.hash.sha256.hash(email);
      const hashEmail = window.sjcl.codec.hex.fromBits(bitArray);
      profile.profileInfo = {
        email: hashEmail
      }               
    }
    
    window.digitalData = window.digitalData || []
    window.digitalData.length = 0;
    window.digitalData.push({
      event: 'userView',
      user: [
        {
          profile: [{ ...profile }]
        }
      ]
    })
    //console.log('adobe - userView', window.digitalData);

    window.digitalData.push({
      event: 'pageView',
      page: {
        pageInfo: {
          pageUrl,
          country: country,
          language: lang,
          vertical: 'GNL'
        },
        category: {
          pageType: 'commerce',
          primaryCategory: 'n/a',
          subCategory1: 'n/a',
          subCategory2: 'n/a',
          subCategory3: 'n/a',
          subCategory4: 'n/a',
          subCategory5: 'n/a'
        }
      }
    })
    //console.log('adobe - pageView', window.digitalData);
          
  }, [pageUrl, isLoggedIn, email])
          
}